import { render, staticRenderFns } from "./ShootAddForm.vue?vue&type=template&id=98556ef0"
import script from "./ShootAddForm.vue?vue&type=script&lang=js"
export * from "./ShootAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports